import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useConnectionErrorEnabled } from '@/hooks/useAccountConnectionError';

/**
 * Legacy connection-error indicator for the Balance Sheet widget. Renders only
 * when the new flag-gated connection-error feature is disabled for the user, so
 * feature-on users see only the new SyncErrorIcon and feature-off users keep the
 * indicator they had before the feature (EUD-784).
 *
 * Uses an MUI SVG icon rather than a Material Icons font ligature
 * (`<span class="material-icons">sync_problem</span>`). The main app loads that
 * font from Google Fonts; the Salesforce / embeddable widget host does not, so
 * the ligature previously rendered as the raw red string "sync_problem".
 */
export const BalanceSheetLegacyErrorIcon: React.FC<{ hasError?: boolean }> = ({
  hasError,
}) => {
  const isConnectionErrorEnabled = useConnectionErrorEnabled();

  if (!hasError || isConnectionErrorEnabled) {
    return null;
  }

  return (
    <ErrorOutlineIcon
      data-testid='balance-sheet-legacy-error-icon'
      color='error'
      fontSize='small'
      sx={{ verticalAlign: 'middle' }}
    />
  );
};
